import script from "./forgot-password.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-password.vue?vue&type=script&setup=true&lang=js"

import "./forgot-password.vue?vue&type=style&index=0&id=4952de5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4952de5c"]])

export default __exports__